import React from "react";
import Footer from "../Footer";

const ReturnPolicy = (props) => {
  return (
    <>
      <div style={containerStyle}>
        <h1 style={headingStyle}>Return Policy</h1>

        <p style={textStyle}>
          At Kiko Live, the return and refund policies may differ based on the
          seller and the product category.
        </p>

        <h2 style={subHeadingStyle}>Return Policy for ONDC Network Sellers</h2>
        <p style={textStyle}>
          For products sold by sellers on the ONDC Network, some items are marked
          as non-returnable. This will be clearly noted on the product page.
        </p>

        <h3 style={subHeadingStyle}>Cancellable Orders</h3>
        <ul style={listStyle}>
          <li>Customers can cancel eligible orders at any time before shipment.</li>
          <li>Once an order has been shipped, cancellation is no longer possible.</li>
        </ul>

        <h3 style={subHeadingStyle}>Returnable Items</h3>
        <ul style={listStyle}>
          <li>
            For returnable items, customers can initiate returns through the My
            Orders section.
          </li>
          <li>
            Products must be returned in their original condition for the return
            to be accepted.
          </li>
          <li>
            The seller will arrange for the pickup of the returned item, and a
            refund will be issued once the product has been received and inspected
            by the seller.
          </li>
        </ul>

        <h2 style={subHeadingStyle}>Seller-Specific Return Policies</h2>
        <p style={textStyle}>
          The return policy outlines the actions to be taken if customers require
          post-delivery support. This can include exchanges, replacements, or
          refunds, depending on the situation. A transparent return policy ensures
          customer satisfaction and builds trust, which is beneficial to sellers
          in the long term.
        </p>
        <h3 style={subHeadingStyle}>Proof of Dispatch (POD):</h3>
        <p style={textStyle}>
          When post-delivery support is requested, sellers must provide proof of
          dispatch, including images or videos of the product both in its package
          and unpacked. These visuals help verify the condition of the items
          delivered.
        </p>

        <h2 style={subHeadingStyle}>Return Scenarios and Resolution Process</h2>
        <h3 style={subHeadingStyle}>Defective, Damaged, or Incorrect Items</h3>
        <ul style={listStyle}>
          <li>
            If a product is defective, damaged, or not as described, the seller
            must provide proof of dispatch (photos/videos).
          </li>
          <li>
            If the seller is at fault, the order will be disputed, and the seller
            must either replace the item or confirm a refund and arrange for
            pickup.
          </li>
          <li>
            The seller will bear the logistics costs for both the return and
            replacement shipments.
          </li>
          <li>
            <strong>Estimated Time for Resolution (ETR):</strong> 7 days.
          </li>
        </ul>

        <h2 style={subHeadingStyle}>Additional Return Terms</h2>
        <ul style={listStyle}>
          <li>
            Sellers must confirm replacement or refund within 2 days if:
            <ul style={listStyle}>
              <li>
                The product was damaged before shipment and was not harmed during
                transit.
              </li>
              <li>
                Packaging guidelines were not followed, causing damage during
                delivery.
              </li>
              <li>
                The item does not match the description on the product page.
              </li>
              <li>
                The product is expired, unsuitable for its intended use, or
                missing essential parts.
              </li>
            </ul>
          </li>
        </ul>

        <h2 style={subHeadingStyle}>Contact Us</h2>
        <p style={textStyle}>
          For any inquiries related to returns, please reach out to our customer
          support team via email at <a href="mailto:help@kiko.live">help@kiko.live</a>.
        </p>
      </div>
      <Footer />
    </>
  );
};

const containerStyle = {
  fontFamily: "Arial, sans-serif",
  margin: "20px auto",
  padding: "20px",
  maxWidth: "800px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
};

const headingStyle = {
  textAlign: "center",
  color: "#333",
  marginBottom: "20px",
};

const subHeadingStyle = {
  color: "#444",
  margin: "15px 0 10px 0",
  fontSize: "18px",
  fontWeight: "bold",
};

const textStyle = {
  lineHeight: "1.6",
  color: "#555",
  marginBottom: "10px",
};

const listStyle = {
  marginLeft: "20px",
  color: "#555",
  lineHeight: "1.6",
};


export default ReturnPolicy;
